<p-dialog
  [header]="'Common.Button.TakePhoto' | translate"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '640px', maxWidth: '95vw' }"
  [closable]="false"
  appendTo="body"
  (onHide)="close()"
>
  <ng-template pTemplate="content">
    <div *ngIf="cameraError" class="p-error p-text-center p-p-3">
      {{ 'Common.Validate.CameraNotFound' | translate }}
    </div>
    <div class="camera-video-container" [hidden]="cameraError">
      <video #videoElement autoplay playsinline muted></video>
      <canvas #canvas style="display: none;"></canvas>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="p-button-secondary"
      [label]="'Common.Button.Cancel' | translate"
      (click)="close()"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-sync"
      class="p-button-action p-button-outlined"
      [label]="'Common.Button.SwitchCamera' | translate"
      (click)="switchCamera()"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-camera"
      [label]="'Common.Button.CapturePhoto' | translate"
      [disabled]="!isReady"
      (click)="capture()"
    ></button>
  </ng-template>
</p-dialog>
